window.phoneFormatter = function(value, row) {
    if (value) {
        return '<a href="tel:'+value+'">'+value+'</i>';
    }
};
